export interface TokenPair {
	accessToken: string
	refreshToken: string
}

// OTTClient обменивает одноразовый токен (OTT) на пару access/refresh.
export class OTTClient {
	constructor(private readonly authURL: string) {}

	// exchange отправляет POST /oauth/ott/exchange и возвращает пару токенов.
	async exchange(ott: string): Promise<TokenPair> {
		const response = await fetch(`${this.authURL}/oauth/ott/exchange`, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ ott }),
		})

		if (!response.ok) {
			throw new Error(`OTT exchange failed: status ${response.status}`)
		}

		const data = await response.json()
		return {
			accessToken: data.access_token,
			refreshToken: data.refresh_token,
		}
	}
}
